import { IVehicle } from "../../interfaces/session/IVehicle";
import { DEFAULT_FORMAT } from "./helper";

export function getVehicleName(vehicle: IVehicle = {}, format = DEFAULT_FORMAT, categoryFitmentOptions?: string[]) {
  if (!vehicle) {
    return "";
  }
  const vehicleName = format.map((f) => vehicle[f]).join(" ");
  if (categoryFitmentOptions) {
    return vehicle.fitmentOptions
      .reduce((acc, fo) => (categoryFitmentOptions.includes(fo.optionName) ? `${acc} ${fo.optionValue}` : acc), "");
  }
  return vehicleName;
}
